import { Controller } from "@hotwired/stimulus"

// Controller para manejar la interacción de los checkboxes de preferencias alimentarias
export default class extends Controller {
  connect() {
    // Inicializar estado visual de los checkboxes
    this.initializeCheckboxes()
    
    // Agregar listeners a todos los checkboxes
    this.element.querySelectorAll('.food-preference-checkbox, .recipe-preference-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this))
    })
  }

  initializeCheckboxes() {
    // Inicializar checkboxes de ingredientes
    this.element.querySelectorAll('.food-preference-checkbox').forEach(checkbox => {
      const item = checkbox.closest('.food-preference-item')
      if (checkbox.checked) {
        item?.classList.add('disliked')
      }
    })

    // Inicializar checkboxes de recetas
    this.element.querySelectorAll('.recipe-preference-checkbox').forEach(checkbox => {
      const item = checkbox.closest('.recipe-preference-item')
      if (checkbox.checked) {
        item?.classList.add('disliked')
      }
    })
  }

  handleCheckboxChange(event) {
    const checkbox = event.target
    const item = checkbox.closest('.food-preference-item, .recipe-preference-item')
    
    if (checkbox.checked) {
      item?.classList.add('disliked')
    } else {
      item?.classList.remove('disliked')
    }
  }
}

